import React from "react";
import * as fetchingState from '../../../constants/fetchingState';
import { Alert, Glyphicon } from "react-bootstrap";
import moment from "moment";
const renderRow = (date, onDelete, isReadOnly) => (
    <tr key={date.Date}>
        <td>{moment(date.Date).format("DD.MM.YYYY")}</td>
        {date.IsWeekend && <td colSpan={2} style={{ textAlign: 'center' }}>Выходной</td>}
        {!date.IsWeekend && <td>{date.PickupStartTime} - {date.PickupEndTime}</td>}
        {!date.IsWeekend && <td>{date.OffloadStartTime} - {date.OffloadEndTime}</td>}
        <td>
            <Glyphicon glyph='trash' 
            className={`remove-glyph${isReadOnly ? '.disabled' : ''}`} 
            onClick={isReadOnly ? undefined : () => onDelete(date)} />
        </td>
    </tr>);

export const Table = ({ schedule, fetching, onDelete, isReadOnly }) => (
    <div>
        {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
        {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
        {fetching === fetchingState.FETCHED &&
            <table className='table table-hover'>
                <thead>
                    <tr>
                        <td>Дата</td>
                        <td>Время приема</td>
                        <td>Время доставки</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {schedule.map(d => renderRow(d, onDelete, isReadOnly))}
                </tbody>
            </table>}
    </div>);


// WEBPACK FOOTER //
// ./src/components/settings/schedule/ScheduleTable.jsx